import { AppEntities } from "../../config/entities";
import { ReturnOfGOodsFromCustomersDto } from "../../dtos/documents/ReturnOfGoodsFromCustomers/ReturnOfGoodsFromCustomersDto";
import { ReturnOfGoodsFromCustomersModel } from "../../models/Documents/ReturnOfGOodsFromCustomers/ReturnOfGoodsFromCustomersModel";
import { DocumentService } from "./DocumentService";

export class ReturnOfGOodsFromCustomersService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
    async createBasedAtOrder(id:string){
        const orderDto = await AppEntities.CustomerInvoices.getDataService().Get(id);
        const newReturnOfGOodsFromCustomersService:ReturnOfGOodsFromCustomersDto = {...orderDto};
        return newReturnOfGOodsFromCustomersService;
    };
}